import {
    DocumentationSectionType, activityLink, activityType, connectorDocLinkDictionary,
    connectorDocLinkPrefix, connectorType, contextType, linksMap
} from '../constants/links.const';

export function getActivityUrl(activity: activityType): string {
    const context: contextType = __IS_FABRIC_DPE__ ? contextType.Trident : contextType.ADF;
    return activityLink[activity]?.[context] || activityLink[activity]?.[contextType.ADF];
}

export function constructDatastoreDocLink(
    type: string,
    isCompute: boolean = false,
    sectionType?: DocumentationSectionType
): string {
    const context: contextType = __IS_FABRIC_DPE__ ? contextType.Trident : contextType.ADF;
    const subLinkName: string = connectorDocLinkDictionary[type]?.[context];
    const prefix = !__IS_FABRIC_DPE__ && isCompute
        ? connectorDocLinkPrefix[context][connectorType.compute]
        : !__IS_FABRIC_DPE__
            ? connectorDocLinkPrefix[context][connectorType.dataStore]
            : connectorDocLinkPrefix[context];
    if (subLinkName) {
        return __IS_FABRIC_DPE__
            ? subLinkName
            : sectionType ? `${prefix}${subLinkName}#${sectionType}` : `${prefix}${subLinkName}`;
    }
    // // For now we don't need this, but we will remove it once all the docs are ready
    // //and we still don't need it
    // else {
    //     return specialConnectorDocLinkDictionary[type]?.[context];
    //     // if (!specificLink && __IS_FABRIC_DPE__) {
    //     //     return `${prefix}`;
    //     // To do: need to remove these codes after the Trident doc is released.
    //     // It's better to change it to `${prefix}`
    //     // prefix = isCompute
    //     //     ? connectorDocLinkPrefix[contextType.ADF][connectorType.compute]
    //     //     : connectorDocLinkPrefix[contextType.ADF][connectorType.dataStore];
    //     // subLinkName = connectorDocLinkDictionary[type]?.[contextType.ADF];
    //     // return sectionType ? `${prefix}${subLinkName}#${sectionType}` : `${prefix}${subLinkName}`;
    //     // }
    //     // return specificLink;
    // }
    return undefined;
}

export function updateLinkInInfoForDifferentContexts(desc: string): string {
    const regex = /href="(.*?)"/;
    const oldLink = desc.match(regex)?.[1];
    if (oldLink != null) {
        const newLink = updateLinkForDifferentContexts(oldLink);
        return desc.replace(regex, `href="${newLink}"`);
    }
    return desc;
}

export function updateLinkForDifferentContexts(oldLink: string): string {
    const context: contextType = __IS_FABRIC_DPE__ ? contextType.Trident : contextType.ADF;
    return linksMap[oldLink]?.[context] || oldLink;
}
